import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {EmpresasService} from '../../superadmin/services/empresas.service';
import {KendoPopupUtils} from '../../lib/KendoPopupUtils';
import {CadastroCartaoIuguComponent} from '../cadastro-cartao-iugu/cadastro-cartao-iugu.component';

@Component({
  selector: 'app-assinatura-cadastro-cartao',
  templateUrl: './assinatura-cadastro-cartao.component.html',
  styleUrls: ['./assinatura-cadastro-cartao.component.scss']
})
export class AssinaturaCadastroCartaoComponent implements OnInit {
  usuario: any = {};
  erro: string;

  constructor(private empresasService: EmpresasService,
              private dialogService: DialogService,
              private activatedRoute: ActivatedRoute) {
    const token = this.activatedRoute.snapshot.params.token;

    this.empresasService.obtenhaContratoAssinatura(token).then((contrato: any) => {
      this.abraModalCadastroCartao(contrato, token);
    }).catch((erro: any) => {
      this.erro = erro;
    });
  }

  ngOnInit(): void {
  }

  abraModalCadastroCartao(contrato: any, token: string) {
    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadastroCartaoIuguComponent,
      minWidth: 250,
      width: window.innerWidth - 150,
      maxHeight: window.innerHeight - 100,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    windowRef.content.instance.contrato = contrato;
    windowRef.content.instance.tokenPublico = token;
    windowRef.content.instance.modal = true;
  }
}
